import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ProjectStatusReportComponent } from './project-status-report.component';

const routes: Routes = [
  {
    path: '',
    component: ProjectStatusReportComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProjectStatusReportRoutingModule { }
